import DSIconButton from '../../../../design-system/DSIconButton';
import DSPrimaryButton from '../../../../design-system/DSPrimaryButton';
import EditIcon from '@mui/icons-material/Edit';

interface EditButtonProps {
  onClick: () => void;
  variant?: 'primary' | 'secondary';
}

const EditButton = ({ onClick, variant = 'secondary' }: EditButtonProps) => {
  if (variant === 'primary') {
    return (
      <DSPrimaryButton size="small" onClick={onClick}>
        Edit
      </DSPrimaryButton>
    );
  }

  return (
    <DSIconButton size="small" onClick={onClick} sx={{ padding: 1 }}>
      <EditIcon />
    </DSIconButton>
  );
};

export default EditButton;
